import AvatarBox from 'components/AvatarBox';
import Text from 'components/Text';
import React, { useMemo, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import StaffSearchInput from './StaffSearchInput';
import clsx from 'clsx';
import selectedIcon from './select-box.svg';
import Box from 'components/Box';
import Empty from 'components/Empty';
import Spin from 'components/Spin';

export type IAddStaffFormProps = {
  staffIds?: string[]
  onPickStaff: (option: IStaffItemData) => void;
  staffs?: IStaffItemData[];
  noneSearch?: boolean;
  loading?: boolean;
};
const AddStaffFormV2: React.FC<IAddStaffFormProps> = ({ loading, noneSearch, staffIds, onPickStaff, staffs: staffsProps }) => {
  const staffStore = shopSelectors.data.staffs();
  const staffList = useMemo(() => staffsProps || staffStore?.filter(o => !o.anyBody) || [], [staffsProps, staffStore]);
  const [searchText] = useState('');
  const initOptions = useMemo(() => {
    return staffList.map(o => ({
      ...o,
      label: o.firstName,
      value: o.id,
      keyword: o.firstName.toLowerCase(),
    }));
  }, [staffList]);

  const options = useMemo(() => {
    if (!searchText.trim()) return initOptions;

    return initOptions.filter((item) =>
      item.keyword.includes(searchText.toLowerCase())
    );
  }, [initOptions, searchText]);

  const handleClickItem = (data: IStaffItemData) => {
    onPickStaff(data);
  };

  return (
    <AddStaffFormStyled className={'v2'}>
      <ContainerStaffV2 style={{ position: 'relative' }}>
        {!noneSearch && <>
          <div className="input-search-container">
            <StaffSearchInput onPickAll={() => undefined} v2 onPickStaff={onPickStaff} />
          </div>
        </>}
        <Text mb={.5} />
        {!!loading && <Box bottom='0' top='0' left='0' right='0' style={{ zIndex: 99, background: 'rgba(255,255,255,0.5)' }} position='absolute' my='4' justifyContent='center' display='flex' alignSelf='stretch' alignItems='center' >
          <Spin />
        </Box>}
        {!options.length && !loading && <Box my='4' justifyContent='center' display='flex' alignSelf='stretch' alignItems='center' >
          <Empty description='No Data' />
        </Box>}
        <div className="staff-list">
          {options.map((item) => {
            return (
              <div
                className={clsx('staff-box', staffIds?.includes(item.id) && 'active')}
                key={item.id}
                onClick={() => handleClickItem(item)}
              >
                <AvatarBoxStyled
                  className='AvatarBox'
                  src={item.urlImage}
                  name={item.firstName}
                  anybody={item.anyBody}
                />
                {staffIds?.includes(item.id) && <img src={selectedIcon} alt="selected-icon" className='selected-icon' />}
              </div>
            );
          })}
        </div>
      </ContainerStaffV2>
    </AddStaffFormStyled>
  );
};
const AvatarBoxStyled = styled(AvatarBox)`
width: unset;
`;
export default AddStaffFormV2;
const ContainerStaffV2 = styled.div`
  background: #F5F5F5;
  flex: 1;
  .input-search-container {
    background: #FFF;
    padding: 16px;
  }
  .staff-list {
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(160px, 1fr));
    gap: 8px;
    padding: 0px 16px;
  }
  .staff-box {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 5px;
    background: #FFF;
    position: relative;
    
    &:hover {
      background: #C6E9EF;
      .AvatarBox {
        background: #C6E9EF;
        border-color: #C6E9EF;
      }
    }

    .selected-icon {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 6px;
      top: 6px;
    }

    &.active {
      border-radius: 5px;
      border: 1px solid #6FABB6;
      background: #C6E9EF;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #245963 inset;  
      .AvatarBox {
        background: #C6E9EF;
        border-color: #C6E9EF;
      }
    }
  }
  .CONTENT_2 {
    font-size: 24px;
  }

  .StaffSearchInput .ant-input-affix-wrapper {
    border-radius: 100px;
    padding: 0px;
    .ant-input-suffix {
      display: flex;
      width: 56px;
      height: 56px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 0px 100px 100px 0px;
      background: #2D6772;
    }
    input {
      border-radius: 100px; 
      padding: 24px;
      height: 56px;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px; /* 166.667% */
      text-transform: capitalize;
      align-self: center;
    }
    border: 3px solid #2D6772;
    background: #FFF;
  }
`;
const AddStaffFormStyled = styled.div`
  min-height: 40rem;
  &.v2 {
    display: flex;
  }
`;